import { Injectable, signal } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private readonly notificationSignal = signal<any>(null);
    readonly notification = this.notificationSignal.asReadonly();

    sendNotification(notification: any) {
        this.notificationSignal.set(notification);
    }
    clearNotification() {
        this.notificationSignal.set(null);
    }
}